// In every file you need this!
import $ from 'jquery';
//attach jquery to dom
window.jQuery = $;
window.$ = $;

jQuery(function($) {
  // To display the product that you want via radio button click
  $('.donate_wrapper .choose_donation_type input').on('click', function() {
    if ($(this).val() == "one_off") {
      location.replace('https://thecharliegardfoundation.org/make-a-donation/?donation_type=one_off');
    } else {
      location.replace('https://thecharliegardfoundation.org/make-a-donation/?donation_type=regular'); 
    }
  });

  // Custom class toggling to style the variable product radio buttons used
  $('.donate_wrapper .woovr-variation-name').on('click', function() {
    $(".woovr-variation").removeClass("woovr-checked");
    $(this).closest(".woovr-variation").addClass("woovr-checked");
  });
});